var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { constVoid } from 'fp-ts/lib/function';
import * as React from 'react';
import { forwardRef } from 'react';
import { Button, Spinner } from 'reactstrap';
var spinnerStyle = { height: '1em', width: '1em', borderWidth: '0.15em', position: 'relative', top: -1 };
var spinner = React.createElement(Spinner, { style: spinnerStyle });
export var LoadingButton = forwardRef(function (_a, ref) {
    var pending = _a.pending, origChildren = _a.children, origOnClick = _a.onClick, props = __rest(_a, ["pending", "children", "onClick"]);
    var children = pending ? spinner : origChildren;
    var onClick = pending ? constVoid : origOnClick;
    return (React.createElement(Button, __assign({}, props, { onClick: onClick, innerRef: ref }), children));
});
//# sourceMappingURL=LoadingButton.js.map